"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentationSiteMap = exports.Documentation = exports.References = exports.RuleLink = exports.Explanation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const publicodes_1 = require("publicodes");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("./contexts");
const References_1 = __importDefault(require("./rule/References"));
exports.References = References_1.default;
const RulePage_1 = __importDefault(require("./rule/RulePage"));
const { decodeRuleName, encodeRuleName } = publicodes_1.utils;
var Explanation_1 = require("./Explanation");
Object.defineProperty(exports, "Explanation", { enumerable: true, get: function () { return __importDefault(Explanation_1).default; } });
var RuleLink_1 = require("./RuleLink");
Object.defineProperty(exports, "RuleLink", { enumerable: true, get: function () { return RuleLink_1.RuleLink; } });
function Documentation({ documentationPath, engine, referenceImages = {}, }) {
    return (jsx_runtime_1.jsx(contexts_1.EngineContext.Provider, Object.assign({ value: engine }, { children: jsx_runtime_1.jsx(contexts_1.BasepathContext.Provider, Object.assign({ value: documentationPath }, { children: jsx_runtime_1.jsx(contexts_1.ReferencesImagesContext.Provider, Object.assign({ value: referenceImages }, { children: jsx_runtime_1.jsx(react_router_dom_1.Route, { path: documentationPath + '/:name+', render: ({ match }) => {
                        return (jsx_runtime_1.jsx(RulePage_1.default, { dottedName: decodeRuleName(match.params.name), engine: engine, language: 'fr' }, void 0));
                    } }, void 0) }), void 0) }), void 0) }), void 0));
}
exports.Documentation = Documentation;
function getDocumentationSiteMap({ engine, documentationPath }) {
    const parsedRules = engine.getParsedRules();
    return Object.fromEntries(Object.keys(parsedRules)
        // .filter(dottedName =>
        // 	ruleWithDedicatedDocumentationPage(parsedRules[dottedName])
        // )
        .map((dottedName) => [
        documentationPath + '/' + encodeRuleName(dottedName),
        dottedName,
    ]));
}
exports.getDocumentationSiteMap = getDocumentationSiteMap;
